import React from 'react';
import classNames from 'classnames';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { setSelectedMapLayer } from 'manual';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getLayersTypes, getSelectedLayers, getSelectedMapLayer } from 'manual/selectors';
import CardTooltip from 'common/CardTooltip';

const ZoneGenerationLayersTypesSelection = () => {
  const dispatch = useAppDispatch();
  const { selectedMapType } = useAppSelector(getSelectedMapLayer);
  const layersTypes = useAppSelector(getLayersTypes);
  const selectedLayers = useAppSelector(getSelectedLayers);

  const selectLayerType = (layerType: string) => {
    if (layerType !== selectedMapType) {
      dispatch(setSelectedMapLayer({
        selectedMapType: layerType,
        selectedLayerGroup: undefined,
        selectedLayers: undefined
      }));
    }
  };
  
  return (
    <>
      <section data-test-id='layers-types-header'>
        {getMessage('label-text__generate-zones-layers-type-select')}
      </section>
      <ul data-test-id='layers-types-list'>
        {layersTypes.map((layerType) => {
          const isSelected = selectedMapType === layerType;
          const isDisabled = !isSelected && !!selectedMapType && selectedLayers?.length > 0;
          const classString = classNames({
            isDisabled,
            isSelected
          });

          const onClick = isDisabled ? undefined : () => selectLayerType(layerType);

          return (
            <li
              onClick={onClick}
              className={classString}
              data-test-id={`layers-type-${layerType}`}
              key={layerType}
            >
              <span>{getMessage(`label-text__zone-generation-layers-types-${layerType}`)}</span>
              <Icon glyph={Icon.set.ARROW_RIGHT} />
              {isDisabled && <CardTooltip>
                {getMessage('label-text__generate-zones-layer-select-clear-selection')}
              </CardTooltip>}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default ZoneGenerationLayersTypesSelection;
